import { cn } from "@/lib/cn";
import { useFilter } from "../../providers";

const OPTIONS = [
  {
    key: "all",
    label: "All comments",
  },
  {
    key: "for-me",
    label: "For you",
  },
];

export const ForMeFilter = () => {
  const { isForMeFilter, setIsForMeFilter } = useFilter();
  return (
    <div className="tw-relative tw-px-4 tw-pt-1 after:tw-absolute after:tw-bottom-0 after:tw-left-0 after:tw-h-[1px] after:tw-w-full after:tw-bg-blue-100 after:tw-content-['']">
      <div className="tw-flex tw-items-center tw-gap-2">
        {OPTIONS.map((option) => (
          <div
            onClick={() => {
              setIsForMeFilter(option.key === "for-me");
            }}
            key={option.key}
            className={cn(
              "tw-relative tw-flex tw-h-9 tw-cursor-pointer tw-items-center tw-px-4 tw-py-1 tw-font-sans tw-text-[11px]/tight tw-font-semibold tw-text-blue-500 tw-transition-colors tw-duration-200 after:tw-absolute after:tw-bottom-0 after:tw-left-0 after:tw-z-1 after:tw-h-[2px] after:tw-w-full after:tw-bg-[transparent] after:tw-transition-colors after:tw-duration-200 after:tw-content-[''] hover:tw-text-primary-base",
              {
                "tw-text-primary-base after:tw-bg-primary-base":
                  (isForMeFilter && option.key === "for-me") ||
                  (!isForMeFilter && option.key === "all"),
              },
            )}
          >
            {option.label}
          </div>
        ))}
        <span></span>
      </div>
    </div>
  );
};
